import { render } from "./App.vue?vue&type=template&id=23779faa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=23779faa&lang=scss"

import exportComponent from "/Users/peterdevos/Sites/clawmachine_yardi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__